// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"74":"ff064597","241":"ff064597","300":"bcdda772","317":"d189bcc7","508":"ff064597","656":"d888a768","740":"ff064597","810":"d888a768"}[chunkId] + ".chunk.css";
};